import { getUserLocale } from '@/utils/locale';
import { locales, type LocaleKey } from './locales';

export type { LocaleKey };

export function useTranslation() {
  const locale = getUserLocale();
  const strings = locales[locale] || locales['en'];

  function t(key: LocaleKey, params?: Record<string, string>): string {
    let text = strings[key] || locales['en'][key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }

  return { t, locale };
}
